import { render, staticRenderFns } from "./QuizAnswerRow.vue?vue&type=template&id=159025f6&scoped=true"
import script from "./QuizAnswerRow.vue?vue&type=script&lang=js"
export * from "./QuizAnswerRow.vue?vue&type=script&lang=js"
import style0 from "./QuizAnswerRow.vue?vue&type=style&index=0&id=159025f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159025f6",
  null
  
)

export default component.exports